module.exports = __webpack_public_path__ + "img/zm.d04925e6.png";